{
  "it": {
    "baseBtn": {
      "labels": {
        "loading": "Attendere..."
      }
    }
  }
}
